import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import Home from './views/Home.vue'
// import Main from './views/Main.vue'
import consultaGeral from './views/consulta-nfe/geral.vue'
import consultaEspecifica from './views/consulta-nfe/especifica.vue'
import clientes from './views/admin/clientes.vue'
import users from './views/admin/users.vue'
// import Form from './views/consulta-nfe/Form.vue'

let routes = [
  {
    path: '/login',
    component: Login,
    name: '',
    hidden: true
  },
  {
    path: '/404',
    component: NotFound,
    name: '',
    hidden: true
  },
  //{ path: '/main', component: Main },
  {
    path: '/',
    component: Home,
    name: 'Consultas NF-e',
    redirect: '/consulta-geral',
    iconCls: 'fa fa-search',
    role: 'all',
    children: [
      {
        path: '/consulta-geral',
        component: consultaGeral,
        name: 'Geral'
      },
      {
        path: '/consulta-especifica',
        component: consultaEspecifica,
        name: 'Específica'
      },
    ]
  },
  {
    path: '/',
    component: Home,
    name: 'Definições',
    redirect: '/clientes',
    iconCls: 'fa fa-cogs',
    role: 'admin',
    children: [
      {
        path: '/clientes',
        component: clientes,
        name: 'Clientes'
      },
      {
        path: '/usuarios',
        component: users,
        name: 'Usuários'
      },
    ]
  },
  // {
  //     path: '/',
  //     component: Home,
  //     name: '导航二',
  //     iconCls: 'fa fa-id-card-o',
  //     children: [
  //         { path: '/page4', component: Page4, name: '页面4' },
  //         { path: '/page5', component: Page5, name: '页面5' }
  //     ]
  // },
  // {
  //     path: '/',
  //     component: Home,
  //     name: '',
  //     iconCls: 'fa fa-address-card',
  //     leaf: true,//只有一个节点
  //     children: [
  //         { path: '/page6', component: Page6, name: '导航三' }
  //     ]
  // },
  {
    path: '*',
    hidden: true,
    redirect: { path: '/' }
    // redirect: { path: '/404' }
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js